import type * as THREE from "three";
import { findSelfIntersections } from "./findSelfIntersections";
import { splitAtSelfIntersection } from "./splitAtSelfIntersection";

// Each pass removes at least one crossing, but a pathological ring could keep producing new ones —
// bail out rather than spin.
const MAX_PASSES = 30;

/**
 * Repeatedly cuts off self-intersecting loops, keeping the larger area each time,
 * until the ring is simple.
 */
function removeSelfIntersections({ points }: { points: ReadonlyArray<THREE.Vector3> }): Array<THREE.Vector3> {
	let result = points.map((point) => point.clone());

	for (let pass = 0; pass < MAX_PASSES; pass++) {
		const intersections = findSelfIntersections({ points: result, isLoop: true });

		if (intersections.length === 0) {
			break;
		}

		result = splitAtSelfIntersection({ points: result, intersection: intersections[0] }).keep;
	}

	return result;
}

export { removeSelfIntersections };
